import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { mget, fmtDate, todayISO, SOURCE_LABEL } from "@/manager/lib";
import { PageHeader, Card, KindPill, StatusPill, Empty, goldBtn } from "@/manager/ui";
import EventFormDialog from "@/manager/components/EventFormDialog";

export default function Events() {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [past, setPast] = useState(false);
  const [q, setQ] = useState("");
  const [newEvent, setNewEvent] = useState(false);
  useEffect(() => { mget("/events", past ? {} : { start: todayISO() }).then(setEvents); }, [past]);
  const list = events.filter((e) => `${e.title} ${e.client_name}`.toLowerCase().includes(q.toLowerCase()));
  if (past) list.reverse();
  return (
    <div data-testid="manager-events">
      <PageHeader eyebrow="Eventos" title={past ? "Todos los eventos" : "Próximos eventos"}>
        <Button variant="outline" className="rounded-full" onClick={() => setPast(!past)} data-testid="events-toggle-past">{past ? "Ver solo próximos" : "Ver también pasados"}</Button>
        <Button onClick={() => setNewEvent(true)} className={goldBtn} data-testid="events-new"><Plus size={15} /> Nuevo evento</Button>
      </PageHeader>
      <Input placeholder="Buscar por nombre o cliente…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-sm bg-white mb-4" data-testid="events-search" />
      <Card className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-[0.16em] text-[#6b6a66] bg-[#F7F5F0]">
            <tr>{["Fecha", "Evento", "Invitados", "Camareros", "Línea", "Estado", "Origen"].map((h) => <th key={h} className="text-left px-4 py-3">{h}</th>)}</tr>
          </thead>
          <tbody>
            {list.map((e) => (
              <tr key={e.id} onClick={() => navigate(`/manager/eventos/${e.id}`)} className="border-t border-[#eee9df] cursor-pointer hover:bg-[#F7F5F0]" data-testid={`events-row-${e.id}`}>
                <td className="px-4 py-3 whitespace-nowrap">{fmtDate(e.date)} <span className="text-[#6b6a66]">{e.start_time}</span></td>
                <td className="px-4 py-3"><p className="font-medium">{e.title}</p><p className="text-xs text-[#6b6a66]">{e.client_name}</p></td>
                <td className="px-4 py-3">{e.guests ?? "—"}</td>
                <td className={`px-4 py-3 ${e.staff.missing ? "text-rose-600 font-medium" : "text-emerald-700"}`}>{e.staff.confirmed}/{e.staff.needed}</td>
                <td className="px-4 py-3"><KindPill kind={e.kind} /></td>
                <td className="px-4 py-3"><StatusPill status={e.status} /></td>
                <td className="px-4 py-3 text-xs text-[#6b6a66]">{SOURCE_LABEL[e.external_source] || "Manual"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!list.length && <Empty>No hay eventos.</Empty>}
      </Card>
      <EventFormDialog open={newEvent} onClose={() => setNewEvent(false)} onSaved={(ev) => navigate(`/manager/eventos/${ev.id}`)} />
    </div>
  );
}
